import { lazy } from 'react';

const ManagerPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/register',
			component: lazy(() => import('./ManagerRegistered'))
		}
	]
};

export default ManagerPageConfig;
